import SearchMaterialIcon from "@material-ui/icons/Search";

const SearchIcon = () => <SearchMaterialIcon fontSize="large" />;

export default SearchIcon;
